import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../../context/auth-context";
import UpperbarContext from "../../../context/upperbar-context";
import { Fetchdata } from "../../../hooks/getData";
import Spinner from "../../../loading/spinner";
import { englishToNepaliNumber } from "nepali-number";
import { toast } from "react-toastify";

export default function Default() {
  const { User } = useContext(AuthContext);
  const { appURL, mode } = useContext(UpperbarContext);
  const [loading, setLoading] = useState(true);
  const [payrollHeads, setPayrollHeads] = useState([]);

  useEffect(() => {
    fetchPayrollHeads();
  }, []);

  const fetchPayrollHeads = () => {
    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: User.UID.toString(),
      CID: "1",
      Flag: "SD",
      Type: "POST",
      FetchURL: `${appURL}api/acc/admin/payroll-head`,
    };

    Fetchdata(dataForm).then((result) => {
      if (result.StatusCode === 200) {
        setPayrollHeads(result.Values || []);
        setLoading(false);
      } else {
        setPayrollHeads([]);
        setLoading(false);
      }
    });
  };

  const deactivateData = (ID, IsActive) => {
    const UserID = User.UID.toString();
    const newStatus = IsActive === "A" ? "I" : "A";

    const dataForm = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: UserID,
      CID: "1",
      Flag: "DA",
      HeadID: ID,
      IsActive: newStatus,
      FetchURL: `${appURL}api/acc/admin/payroll-head`,
      Type: "POST",
    };

    Fetchdata(dataForm).then((result) => {
      if (result.StatusCode === 200) {
        fetchPayrollHeads();
        toast.success(result.Message, {
          style: {
            color: "green",
            fontSize: "13px",
          },
          theme: "light",
        });
      } else {
        toast.error("Error: " + result.Message, {
          style: {
            color: "red",
            fontSize: "13px",
          },
          theme: "light",
        });
      }
    });
  };

  const checkStatus = (IsActive) => {
    if (IsActive === "A") {
      return mode === "en" ? "Deactivate" : "निष्क्रिय";
    } else {
      return mode === "en" ? "Activate" : "सक्रिय";
    }
  };

  return (
    <>
      <div className="upper-dataTbl">
        <div className="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle mb-3">
          <div className="uk-flex uk-flex-wrap me-5">
            {/* Maintained header structure */}
          </div>
        </div>
      </div>

      <div className="mt-3 mt-3 tableHeight">
        {loading ? (
          <Spinner />
        ) : (
          <>
            {payrollHeads.length > 0 ? (
              <table className="uk-table reportTable">
                <thead>
                  <tr>
                    <td className="rdt_TableHeadRow tableHead text-center" width="80px">
                      {mode === "en" ? "S.N." : "क्र.सं"}
                    </td>
                    <td className="rdt_TableHeadRow tableHead">
                      {mode === "en" ? "Type" : "प्रकार"}
                    </td>
                    <td className="rdt_TableHeadRow tableHead">
                      {mode === "en" ? "Status" : "स्थिति"}
                    </td>
                  </tr>
                </thead>

                <tbody>
                  {payrollHeads.map((head, index) => (
                    <tr key={head.TypeID}>
                      <td className="rdt_TableCell tablecell text-center">
                        {mode === "en"
                          ? index + 1
                          : englishToNepaliNumber(index + 1)}
                      </td>
                      <td className="rdt_TableCell tablecell text-start">
                        {head.Type}
                      </td>
                      <td className="rdt_TableCell tablecell text-center">
                        <button
                          type="button"
                          className="border-0 bg-transparent"
                          onClick={() => deactivateData(head.TypeID, head.IsActive)}
                        >
                          <span 
                            className={`badge rounded-pill ${
                              head.IsActive === "A" ? "bg-success" : "bg-success"
                            }`}
                            style={{ fontSize: "11px" }}
                          >
                            {checkStatus(head.IsActive)}
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-center">
                {mode === "en" ? "No Data" : "डाटा उपलब्ध छैन"}
              </p>
            )}
          </>
        )}
      </div>
    </>
  );
}